import { App } from "antd";
import { CircleCheck, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";

import BaseButton from "@/components_v2/Button/BaseButton";
import { BUTTON_VARIANTS } from "@/components_v2/Button/constants";
import { useVerifyEmailResendMutation } from "@/redux/service";
import { AccountCreatedConfirmationProps } from "../types";

const AccountCreatedConfirmation = ({
  email,
}: AccountCreatedConfirmationProps) => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const [verifyEmailResend, { isLoading }] = useVerifyEmailResendMutation();

  const handleResend = () => {
    verifyEmailResend({ email })
      .unwrap()
      .then((data) => notification.success({ message: data.message }))
      .catch(() =>
        notification.error({
          message: t("applications.labels.resendVerificationEmailFailed"),
        }),
      );
  };

  return (
    <div className="flex flex-col items-center gap-400 apply-to-join__success">
      <div className="apply-to-join__success-icon-container flex items-center justify-center">
        <CircleCheck
          className="apply-to-join__success-icon"
          aria-hidden="true"
        />
      </div>

      <div className="flex flex-col items-center gap-200 text-center">
        <h2 className="apply-to-join__title header-m-medium">
          {t("applications.labels.accountCreatedTitle")}
        </h2>

        <p className="apply-to-join__description body-m-regular">
          {t("applications.labels.accountCreatedDescription")}
        </p>
      </div>

      <div className="apply-to-join__confirmation-box flex items-center gap-200 full-width">
        <div className="apply-to-join__confirmation-icon-container flex items-center justify-center">
          <Mail
            className="apply-to-join__confirmation-icon"
            aria-hidden="true"
          />
        </div>

        <div className="flex flex-col">
          <span className="body-m-medium apply-to-join__confirmation-label">
            {t("applications.labels.confirmationSent")}
          </span>

          <span className="body-m-regular apply-to-join__confirmation-email">
            {email}
          </span>
        </div>
      </div>

      <BaseButton
        isFullWidth
        variant={BUTTON_VARIANTS.TERTIARY}
        loading={isLoading}
        onClick={handleResend}
      >
        {t("applications.labels.resendVerificationEmail")}
      </BaseButton>
    </div>
  );
};

export default AccountCreatedConfirmation;
